var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headingTag[_vm.size],{tag:"component",class:[{ 'custom-spacing': _vm.isCustomFont } ].concat( _vm.headingClass[_vm.size])},[_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }